import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View, StyleSheet } from 'react-native';
import { Text, useTheme } from 'react-native-paper';
export const OutlineLabel = ({ testID = 'outline-label', ...props }) => {
    const theme = useTheme();
    const { backgroundColor, ...style } = StyleSheet.flatten(props.style);
    return (_jsx(View, { testID: `${testID}-container`, style: [style, { alignSelf: 'flex-start' }], onLayout: props.onLayout, children: _jsxs(View, { children: [_jsx(View, { testID: `${testID}-background`, style: [
                        {
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            left: 0,
                            height: '45%',
                            backgroundColor: backgroundColor || theme.colors.background,
                        },
                    ] }), _jsx(Text, { testID: `${testID}-text`, style: [
                        {
                            marginHorizontal: 5,
                            color: theme.colors.outline,
                            fontSize: 12,
                            fontWeight: 400,
                        },
                        props.labelStyle,
                    ], children: props.label })] }) }));
};
